import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { AddressCardStack } from './address-card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { GanjikaBeverageAddressCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/address-cards-1x3/ganjika-beverage-address-card-stack-content/ganjika-beverage-address-card-stack-content.component';
import { GanjikaBeverageAddressCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/address-cards-1x3/ganjika-beverage-address-card-stack-background/ganjika-beverage-address-card-stack-background.component';
import type { CardData } from '../../../../print-cards/card-data';

export class GanjikaBeverageAddressCardStack extends AddressCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return GanjikaBeverageAddressCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return GanjikaBeverageAddressCardStackContentComponent;
  }

  getCardHeightInInches(): number {
    return 1.25;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 12;
  }

  nRows(): number {
    return 6;
  }
}
